import React from 'react';
import Existencias from 'src/components/Existencias';
import ResponsiveWrapper from 'src/components/ResponsiveWrapper';

const ProxyExistencias = () => {
    return (
        <ResponsiveWrapper>
            <Existencias />
        </ResponsiveWrapper>
    );
};

export default ProxyExistencias;
